
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { AlertCircle, ArrowLeft } from 'lucide-react';

interface ProductNotFoundProps {
  shopSlug?: string;
}

const ProductNotFound = ({ shopSlug }: ProductNotFoundProps) => {
  return (
    <div className="container mx-auto py-16 px-4 text-center">
      <div className="max-w-md mx-auto">
        <div className="mb-6 flex justify-center">
          <AlertCircle className="h-16 w-16 text-amber-500" />
        </div>
        <h1 className="text-3xl font-bold mb-4">Produit non trouvé</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          Désolé, nous n'avons pas pu trouver le produit que vous recherchez.
        </p>
        {shopSlug && (
          <Button asChild>
            <Link to={`/shop/${shopSlug}`}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Retour à la boutique
            </Link>
          </Button>
        )}
      </div>
    </div>
  );
};

export default ProductNotFound;
